import React, { useState } from "react";

import { useSelector, useDispatch } from "react-redux";
import { selectSearch, setSearchOption } from "amadeusredux/lib/searchSlice";

export default function MapOption(props) {
    const { stations } = useSelector(selectSearch);


    return(
        <div className={props.cname} onClick={()=>props.handleClick()}>
            <div className="optioninput">
            <input  type="checkbox" checked={props.checked} readOnly onClick={props.handleClick}></input>
            </div>
            {" "}
            <div className="optionlabel">
            <label >{props.label}</label>
            </div>
        </div>
    )
}